import API from "../util/api";

export const getRoles = async (params = {}) => {
    let data = null;

    await API.get('/roles', {params})
        .then(res => {
            data = res.data;
        })
        .catch((err) => {
            throw new Error(JSON.stringify(err.response.data))
        });

    return data;
};

export const deleteRole = async (payload) => {
    await API.delete('/roles/'+payload.id)
        .catch((err) => {
            throw new Error(JSON.stringify(err.response.data))
        });

    return true;
}

export const updateRole = async (id, payload) => {
    let data = null;

    await API.patch(`/roles/${id}`, payload)
        .then(res => {
            data = res.data.data;
        })
        .catch((err) => {
            throw new Error(JSON.stringify(err.response.data))
        });

    return data;
}

export const storeRole = async (payload) => {
    let data = null;

    await API.post('/roles', payload)
        .then(res => {
            data = res.data.data;
        })
        .catch((err) => {
            throw new Error(JSON.stringify(err.response.data))
        });

    return data;
}
export const getPermissions = async (payload) => {
    let data = null;

    await API.get('/roles-permissions', payload)
        .then(res => {
            data = res.data;
        })
        .catch((err) => {
            throw new Error(JSON.stringify(err.response.data))
        });

    return data;
}



